import uuid from 'uuid-random';
import img1 from "./1.png";
import img2 from "./2.png";
import img3 from "./3.png";
import img4 from "./4.png";
import img5 from "./5.png";
import img6 from "./6.png";
import img7 from "./7.png";
import img8 from "./8.png";
import img9 from "./9.png";
import img10 from "./10.png";
import img11 from "./11.png";
import img12 from "./12.png";
import img13 from "./13.png";
import img14 from "./14.png";
import img15 from "./15.png";
import img16 from "./16.png";
import img17 from "./17.png";
import img18 from "./18.png";
import img19 from "./19.png";
import img20 from "./20.png";
import img21 from "./21.png";
import img22 from "./22.png";
import img23 from "./23.png";
import img24 from "./24.png";
import img25 from "./25.png";
import img26 from "./26.png";
import img27 from "./27.png";

import another_year from "./another_year.mp3";
import cant_stand_the_rain from "./cant_stand_the_rain.mp3";
import flowers_in_the_window from "./flowers_in_the_window.mp3";
import sunrise from "./sunrise.mp3";
import think_about_things from "./think_about_things.mp3";

import track2 from "./track2.mp3";

let id = 0;
export const images = [
    { image: img1, id: uuid()},
    { image: img2, id: uuid()},
    { image: img3, id: uuid()},
    { image: img4, id: uuid()},
    { image: img5, id: uuid()},
    { image: img6, id: uuid()},
    { image: img7, id: uuid()},
    { image: img8, id: uuid()},
    { image: img9, id: uuid()},
    { image: img10, id: uuid()},
    { image: img11, id: uuid()},
    { image: img12, id: uuid()},
    { image: img13, id: uuid()},
    { image: img14, id: uuid()},
    { image: img15, id: uuid()},
    { image: img16, id: uuid()},
    { image: img17, id: uuid()},
    { image: img18, id: uuid()},
    { image: img19, id: uuid()},
    { image: img20, id: uuid()},
    { image: img21, id: uuid()},
    { image: img22, id: uuid()},
    { image: img23, id: uuid()},
    { image: img24, id: uuid()},
    { image: img25, id: uuid()},
    { image: img26, id: uuid()},
    { image: img27, id: uuid()},
];

export const songs = [
    { song: another_year, title: "Another Year", artist: "Finneas", id: uuid() },
    { song: cant_stand_the_rain, title: "Can't Stand the Rain", artist: "The Rescues", id: uuid()},
    { song: flowers_in_the_window, title: "Flowers in the Window", artist: "Travis", id: uuid()},
    { song: sunrise, title: "Sunrise", artist: "In the Heights", id: uuid()},
    { song: think_about_things, title: "Think About Things", artist: "Daði Freyr", id: uuid()},
];